/**
 * @internal
 */
export const { min, max } = Math;

/**
 * @internal
 */
export const refKey = "current";

/**
 * for caret position detection
 * @internal
 */
export const CARET_DETECTOR = (
  <span style={{ color: "transparent" }}>{"\u200b"}</span>
);
